import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from "react-i18next";
import {bindActionCreators} from "redux";
import {useEffect, useMemo} from "react";
import useModal from "../useModal";
import CustomerActions from "../../Actions/customerActions";
import {
    categorizedCustomerNavigationItems,
    customerNavigationItems
} from "../../Constants/Customer/customerNavigationItems";
import customerActions from "../../Actions/customerActions";

const useCustomerNavigation = () => {
    const { t } = useTranslation();
    const { openModal } = useModal();

    const dispatch = useDispatch();
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const user = useSelector((state) => state.CommonReducer.user);
    const externalUrls = useSelector((state) => state.CommonReducer.externalUrls);
    const customerInfoCounts = useSelector((state) => state.CustomerReducer.customerInfoCounts);
    const infoFlagsLoading = useSelector((state) => state.CommonReducer.dataLoading.customerInfoFlags);
    
    useEffect(() => {
        if (customer?.vbCustomer && !customerInfoCounts && !infoFlagsLoading) {
            dispatch(customerActions.getCustomerInfoFlags(customer));
        }
    }, [])
    
    const params = useMemo(() => ({
        user,
        customer,
        externalUrls,
        customerInfoCounts,
        openModal,
        customerActions: bindActionCreators(CustomerActions, dispatch)
    }), [customer, customerInfoCounts]);
    
    const fillRouteParams = (link) => link.routeFunc ? link.routeFunc(params) : link.route;
    const getBadgeValue = (link) => link.badgeFunc ? link.badgeFunc(params) : link.badgeNumber;
    
    const getLabel = (link) => {
        if (!link) return "getLabel: missing link";
        let title = link.title;

        if (link.titleFunc)
            title = link.titleFunc(params);

        return t(title);
    }

    const processNavItems = (items) => items.map(item => {
        const newItem = { ...item, link: { ...item.link } };
        if (newItem.link.routeFunc) newItem.link.route = fillRouteParams(newItem.link);
        if (newItem.link.badgeFunc) newItem.badgeNumber = getBadgeValue(newItem.link);
        if (newItem.link.onClickFunc) newItem.onClick = () => newItem.link.onClickFunc(params);
        if (newItem.link.subItems) newItem.link.subItems = processNavItems(newItem.link.subItems);
        return newItem;
    });
    
    const categorizedItems = (items = categorizedCustomerNavigationItems) =>
        items.filter(item => !(item.link.hiddenFunc && item.link.hiddenFunc(params)))
            .map(item => {
                if (item.link){
                    const newItem = { ...item };
                    if (newItem.link.disabledFunc) newItem.disabled = newItem.link.disabledFunc(params);
                    newItem.link.label = getLabel(newItem.link);
                    if (newItem.link.subItems) {
                        newItem.link.subItems = categorizedItems(newItem.link.subItems);
                    }
                    return newItem;
                }
            });

    const navigationItems = () =>
        Object.values(customerNavigationItems)
            .filter(item => !(item.hiddenFunc && item.hiddenFunc(params)))
            .map(item => {
                const link = { ...item };
                if (link.disabledFunc) link.disabled = link.disabledFunc(params);
                if (link.routeFunc) link.route = fillRouteParams(link);
                if (link.onClickFunc) link.onClick = () => link.onClickFunc(params);
                link.label = getLabel(link);
                return link;
            });

    return {
        processNavItems,
        fillRouteParams,
        categorizedItems,
        navigationItems,
    };
};

export default useCustomerNavigation;
